"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import Newsletter from "@/components/landing/newsletter";
import { useAppConfig } from "@/lib/config";
import { useI18n } from "@llmgateway/i18n/react";
import { providers as providerDefinitions } from "@llmgateway/models";
interface FooterProps {
  configuredProviderIds?: string[];
}
export default function Footer(t0) {
  const $ = _c(281);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    configuredProviderIds
  } = t1;
  const config = useAppConfig();
  const {
    t
  } = useI18n();
  const effectiveConfiguredProviderIds = configuredProviderIds ?? config.configuredProviderIds;
  let t2;
  if ($[2] !== effectiveConfiguredProviderIds) {
    t2 = new Set(effectiveConfiguredProviderIds);
    $[2] = effectiveConfiguredProviderIds;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const configuredProviderIdSet = t2;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[4] !== config.docsUrl || $[5] !== config.playgroundUrl || $[6] !== configuredProviderIdSet || $[7] !== t) {
    let t15;
    if ($[20] !== configuredProviderIdSet) {
      t15 = p => p.name !== "doteb" && configuredProviderIdSet.has(p.id);
      $[20] = configuredProviderIdSet;
      $[21] = t15;
    } else {
      t15 = $[21];
    }
    const filteredProviders = providerDefinitions.filter(t15);
    t13 = "relative py-12 bg-background";
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-border to-transparent" />;
      $[22] = t14;
    } else {
      t14 = $[22];
    }
    t11 = "container mx-auto px-4";
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <Newsletter />;
      $[23] = t12;
    } else {
      t12 = $[23];
    }
    t9 = "flex flex-col md:flex-row md:justify-between md:items-start";
    let t16;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <span className="relative flex h-2 w-2"><span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75" /><span className="relative inline-flex h-2 w-2 rounded-full bg-green-500" /></span>;
      $[24] = t16;
    } else {
      t16 = $[24];
    }
    let t17;
    if ($[25] !== t) {
      t17 = t("landing.footer.status");
      $[25] = t;
      $[26] = t17;
    } else {
      t17 = $[26];
    }
    let t18;
    if ($[27] !== t17) {
      t18 = <a href="https://status.doteb.com/" target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex items-center gap-2 rounded-full border border-border/60 bg-card/40 px-3 py-1.5 text-xs text-muted-foreground transition-colors hover:border-foreground/30 hover:text-foreground">{t16}{t17}</a>;
      $[27] = t17;
      $[28] = t18;
    } else {
      t18 = $[28];
    }
    let t19;
    if ($[29] !== t) {
      t19 = t("landing.footer.socAlt");
      $[29] = t;
      $[30] = t19;
    } else {
      t19 = $[30];
    }
    let t20;
    if ($[31] !== t19) {
      t20 = <a href="https://www.aicpa.org/soc4so" target="_blank" rel="noopener noreferrer"><img src="/badges/aicpa-soc.png" alt={t19} width={56} height={56} loading="lazy" className="h-14 w-14" /></a>;
      $[31] = t19;
      $[32] = t20;
    } else {
      t20 = $[32];
    }
    let t21;
    if ($[33] !== t) {
      t21 = t("landing.footer.socLine1");
      $[33] = t;
      $[34] = t21;
    } else {
      t21 = $[34];
    }
    let t22;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = <br />;
      $[35] = t22;
    } else {
      t22 = $[35];
    }
    let t23;
    if ($[36] !== t) {
      t23 = t("landing.footer.socLine2");
      $[36] = t;
      $[37] = t23;
    } else {
      t23 = $[37];
    }
    let t24;
    if ($[38] !== t21 || $[39] !== t23) {
      t24 = <div className="text-xs leading-snug text-muted-foreground">{t21}{t22}{t23}</div>;
      $[38] = t21;
      $[39] = t23;
      $[40] = t24;
    } else {
      t24 = $[40];
    }
    let t25;
    if ($[41] !== t20 || $[42] !== t24) {
      t25 = <div className="mt-6 flex items-center gap-3">{t20}{t24}</div>;
      $[41] = t20;
      $[42] = t24;
      $[43] = t25;
    } else {
      t25 = $[43];
    }
    if ($[44] !== t18 || $[45] !== t25) {
      t10 = <div className="mb-8 md:mb-0 md:w-48 md:shrink-0">{t18}{t25}</div>;
      $[44] = t18;
      $[45] = t25;
      $[46] = t10;
    } else {
      t10 = $[46];
    }
    t3 = "w-full md:w-auto grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 text-muted-foreground";
    let t26;
    if ($[47] !== t) {
      t26 = t("landing.footer.product");
      $[47] = t;
      $[48] = t26;
    } else {
      t26 = $[48];
    }
    let t27;
    if ($[49] !== t26) {
      t27 = <h3 className="font-display text-sm font-semibold mb-4 text-foreground">{t26}</h3>;
      $[49] = t26;
      $[50] = t27;
    } else {
      t27 = $[50];
    }
    let t28;
    if ($[51] !== t) {
      t28 = t("landing.footer.features");
      $[51] = t;
      $[52] = t28;
    } else {
      t28 = $[52];
    }
    let t29;
    if ($[53] !== t28) {
      t29 = <li><a href="#features" className="text-sm hover:underline underline-offset-4 hover:text-foreground">{t28}</a></li>;
      $[53] = t28;
      $[54] = t29;
    } else {
      t29 = $[54];
    }
    let t30;
    if ($[55] !== t) {
      t30 = t("landing.footer.models");
      $[55] = t;
      $[56] = t30;
    } else {
      t30 = $[56];
    }
    let t31;
    if ($[57] !== t30) {
      t31 = <li><Link href="/models" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t30}</Link></li>;
      $[57] = t30;
      $[58] = t31;
    } else {
      t31 = $[58];
    }
    let t32;
    if ($[59] !== t) {
      t32 = t("landing.footer.providers");
      $[59] = t;
      $[60] = t32;
    } else {
      t32 = $[60];
    }
    let t33;
    if ($[61] !== t32) {
      t33 = <li><Link href="/providers" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t32}</Link></li>;
      $[61] = t32;
      $[62] = t33;
    } else {
      t33 = $[62];
    }
    const t34 = config.playgroundUrl;
    let t35;
    if ($[63] !== t) {
      t35 = t("landing.footer.chatPlayground");
      $[63] = t;
      $[64] = t35;
    } else {
      t35 = $[64];
    }
    let t36;
    if ($[65] !== config.playgroundUrl || $[66] !== t35) {
      t36 = <li><a href={t34} className="text-sm hover:underline underline-offset-4 hover:text-foreground" rel="noopener" target="_blank">{t35}</a></li>;
      $[65] = config.playgroundUrl;
      $[66] = t35;
      $[67] = t36;
    } else {
      t36 = $[67];
    }
    let t37;
    if ($[68] !== t) {
      t37 = t("landing.footer.changelog");
      $[68] = t;
      $[69] = t37;
    } else {
      t37 = $[69];
    }
    let t38;
    if ($[70] !== t37) {
      t38 = <li><Link href="/changelog" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t37}</Link></li>;
      $[70] = t37;
      $[71] = t38;
    } else {
      t38 = $[71];
    }
    let t39;
    if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
      t39 = <li><a href="https://devpass.doteb.com" className="text-sm hover:underline underline-offset-4 hover:text-foreground">DevPass</a></li>;
      $[72] = t39;
    } else {
      t39 = $[72];
    }
    let t40;
    if ($[73] !== t) {
      t40 = t("landing.footer.compareModels");
      $[73] = t;
      $[74] = t40;
    } else {
      t40 = $[74];
    }
    let t41;
    if ($[75] !== t40) {
      t41 = <li><Link href="/models/compare" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t40}</Link></li>;
      $[75] = t40;
      $[76] = t41;
    } else {
      t41 = $[76];
    }
    let t42;
    if ($[77] !== t) {
      t42 = t("landing.footer.enterprise");
      $[77] = t;
      $[78] = t42;
    } else {
      t42 = $[78];
    }
    let t43;
    if ($[79] !== t42) {
      t43 = <li><Link href="/enterprise" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t42}</Link></li>;
      $[79] = t42;
      $[80] = t43;
    } else {
      t43 = $[80];
    }
    let t44;
    if ($[81] !== t29 || $[82] !== t31 || $[83] !== t33 || $[84] !== t36 || $[85] !== t38 || $[86] !== t41 || $[87] !== t43) {
      t44 = <ul className="space-y-2">{t29}{t31}{t33}{t36}{t38}{t39}{t41}{t43}</ul>;
      $[81] = t29;
      $[82] = t31;
      $[83] = t33;
      $[84] = t36;
      $[85] = t38;
      $[86] = t41;
      $[87] = t43;
      $[88] = t44;
    } else {
      t44 = $[88];
    }
    if ($[89] !== t27 || $[90] !== t44) {
      t4 = <div>{t27}{t44}</div>;
      $[89] = t27;
      $[90] = t44;
      $[91] = t4;
    } else {
      t4 = $[91];
    }
    let t45;
    if ($[92] !== t) {
      t45 = t("landing.footer.resources");
      $[92] = t;
      $[93] = t45;
    } else {
      t45 = $[93];
    }
    let t46;
    if ($[94] !== t45) {
      t46 = <h3 className="font-display text-sm font-semibold mb-4 text-foreground">{t45}</h3>;
      $[94] = t45;
      $[95] = t46;
    } else {
      t46 = $[95];
    }
    let t47;
    if ($[96] !== t) {
      t47 = t("landing.footer.apps");
      $[96] = t;
      $[97] = t47;
    } else {
      t47 = $[97];
    }
    let t48;
    if ($[98] !== t47) {
      t48 = <li><Link href="/apps" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t47}</Link></li>;
      $[98] = t47;
      $[99] = t48;
    } else {
      t48 = $[99];
    }
    let t49;
    if ($[100] !== t) {
      t49 = t("landing.footer.templates");
      $[100] = t;
      $[101] = t49;
    } else {
      t49 = $[101];
    }
    let t50;
    if ($[102] !== t49) {
      t50 = <li><Link href="/templates" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t49}</Link></li>;
      $[102] = t49;
      $[103] = t50;
    } else {
      t50 = $[103];
    }
    let t51;
    if ($[104] !== t) {
      t51 = t("landing.footer.agents");
      $[104] = t;
      $[105] = t51;
    } else {
      t51 = $[105];
    }
    let t52;
    if ($[106] !== t51) {
      t52 = <li><Link href="/agents" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t51}</Link></li>;
      $[106] = t51;
      $[107] = t52;
    } else {
      t52 = $[107];
    }
    let t53;
    if ($[108] !== t) {
      t53 = t("landing.footer.mcpServer");
      $[108] = t;
      $[109] = t53;
    } else {
      t53 = $[109];
    }
    let t54;
    if ($[110] !== t53) {
      t54 = <li><Link href="/mcp" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t53}</Link></li>;
      $[110] = t53;
      $[111] = t54;
    } else {
      t54 = $[111];
    }
    let t55;
    if ($[112] !== t) {
      t55 = t("landing.footer.useCases");
      $[112] = t;
      $[113] = t55;
    } else {
      t55 = $[113];
    }
    let t56;
    if ($[114] !== t55) {
      t56 = <li><Link href="/use-cases" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t55}</Link></li>;
      $[114] = t55;
      $[115] = t56;
    } else {
      t56 = $[115];
    }
    let t57;
    if ($[116] !== t) {
      t57 = t("landing.footer.blog");
      $[116] = t;
      $[117] = t57;
    } else {
      t57 = $[117];
    }
    let t58;
    if ($[118] !== t57) {
      t58 = <li><Link href="/blog" className="text-sm hover:underline underline-offset-4 hover:text-foreground">{t57}</Link></li>;
      $[118] = t57;
      $[119] = t58;
    } else {
      t58 = $[119];
    }
    const t59 = config.docsUrl ?? "";
    let t60;
    if ($[120] !== t) {
      t60 = t("landing.footer.documentation");
      $[120] = t;
      $[121] = t60;
    } else {
      t60 = $[121];
    }
    let t61;
    if ($[122] !== t59 || $[123] !== t60) {
      t61 = <li><a href={t59} target="_blank" className="text-sm hover:underline underline-offset-4 hover:text-foreground">{t60}</a></li>;
      $[122] = t59;
      $[123] = t60;
      $[124] = t61;
    } else {
      t61 = $[124];
    }
    let t62;
    if ($[125] !== t) {
      t62 = t("landing.footer.integrations");
      $[125] = t;
      $[126] = t62;
    } else {
      t62 = $[126];
    }
    let t63;
    if ($[127] !== t62) {
      t63 = <li><Link href="/integrations" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t62}</Link></li>;
      $[127] = t62;
      $[128] = t63;
    } else {
      t63 = $[128];
    }
    let t64;
    if ($[129] !== t) {
      t64 = t("landing.footer.guides");
      $[129] = t;
      $[130] = t64;
    } else {
      t64 = $[130];
    }
    let t65;
    if ($[131] !== t64) {
      t65 = <li><Link href="/guides" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t64}</Link></li>;
      $[131] = t64;
      $[132] = t65;
    } else {
      t65 = $[132];
    }
    let t66;
    if ($[133] !== t) {
      t66 = t("landing.footer.brandAssets");
      $[133] = t;
      $[134] = t66;
    } else {
      t66 = $[134];
    }
    let t67;
    if ($[135] !== t66) {
      t67 = <li><Link href="/brand" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t66}</Link></li>;
      $[135] = t66;
      $[136] = t67;
    } else {
      t67 = $[136];
    }
    let t68;
    if ($[137] !== t) {
      t68 = t("landing.footer.tokenCostCalculator");
      $[137] = t;
      $[138] = t68;
    } else {
      t68 = $[138];
    }
    let t69;
    if ($[139] !== t68) {
      t69 = <li><Link href="/token-cost-calculator" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t68}</Link></li>;
      $[139] = t68;
      $[140] = t69;
    } else {
      t69 = $[140];
    }
    let t70;
    if ($[141] !== t) {
      t70 = t("landing.footer.referralProgram");
      $[141] = t;
      $[142] = t70;
    } else {
      t70 = $[142];
    }
    let t71;
    if ($[143] !== t70) {
      t71 = <li><Link href="/referrals" className="text-sm hover:underline underline-offset-4 hover:text-foreground">{t70}</Link></li>;
      $[143] = t70;
      $[144] = t71;
    } else {
      t71 = $[144];
    }
    let t72;
    if ($[145] !== t) {
      t72 = t("landing.footer.contactUs");
      $[145] = t;
      $[146] = t72;
    } else {
      t72 = $[146];
    }
    let t73;
    if ($[147] !== t72) {
      t73 = <li><a href="mailto:contact@doteb.com" target="_blank" rel="noreferrer noopener" className="text-sm hover:underline underline-offset-4 hover:text-foreground">{t72}</a></li>;
      $[147] = t72;
      $[148] = t73;
    } else {
      t73 = $[148];
    }
    let t74;
    if ($[149] !== t48 || $[150] !== t50 || $[151] !== t52 || $[152] !== t54 || $[153] !== t56 || $[154] !== t58 || $[155] !== t61 || $[156] !== t63 || $[157] !== t65 || $[158] !== t67 || $[159] !== t69 || $[160] !== t71 || $[161] !== t73) {
      t74 = <ul className="space-y-2">{t48}{t50}{t52}{t54}{t56}{t58}{t61}{t63}{t65}{t67}{t69}{t71}{t73}</ul>;
      $[149] = t48;
      $[150] = t50;
      $[151] = t52;
      $[152] = t54;
      $[153] = t56;
      $[154] = t58;
      $[155] = t61;
      $[156] = t63;
      $[157] = t65;
      $[158] = t67;
      $[159] = t69;
      $[160] = t71;
      $[161] = t73;
      $[162] = t74;
    } else {
      t74 = $[162];
    }
    if ($[163] !== t46 || $[164] !== t74) {
      t5 = <div>{t46}{t74}</div>;
      $[163] = t46;
      $[164] = t74;
      $[165] = t5;
    } else {
      t5 = $[165];
    }
    let t75;
    if ($[166] !== t) {
      t75 = t("landing.footer.compare");
      $[166] = t;
      $[167] = t75;
    } else {
      t75 = $[167];
    }
    let t76;
    if ($[168] !== t75) {
      t76 = <h3 className="font-display text-sm font-semibold mb-4 text-foreground">{t75}</h3>;
      $[168] = t75;
      $[169] = t76;
    } else {
      t76 = $[169];
    }
    let t77;
    let t78;
    let t79;
    if ($[170] === Symbol.for("react.memo_cache_sentinel")) {
      t77 = <li><Link href="/compare/open-router" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>OpenRouter</Link></li>;
      t78 = <li><Link href="/compare/litellm" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>LiteLLM</Link></li>;
      t79 = <li><Link href="/compare/portkey" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>Portkey</Link></li>;
      $[170] = t77;
      $[171] = t78;
      $[172] = t79;
    } else {
      t77 = $[170];
      t78 = $[171];
      t79 = $[172];
    }
    let t80;
    if ($[173] !== t) {
      t80 = t("landing.footer.migrationGuides");
      $[173] = t;
      $[174] = t80;
    } else {
      t80 = $[174];
    }
    let t81;
    if ($[175] !== t80) {
      t81 = <ul className="space-y-2">{t77}{t78}{t79}<li><Link href="/migration" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t80}</Link></li></ul>;
      $[175] = t80;
      $[176] = t81;
    } else {
      t81 = $[176];
    }
    if ($[177] !== t76 || $[178] !== t81) {
      t6 = <div>{t76}{t81}</div>;
      $[177] = t76;
      $[178] = t81;
      $[179] = t6;
    } else {
      t6 = $[179];
    }
    let t82;
    if ($[180] !== t) {
      t82 = t("landing.footer.models");
      $[180] = t;
      $[181] = t82;
    } else {
      t82 = $[181];
    }
    let t83;
    if ($[182] !== t82) {
      t83 = <h3 className="font-display text-sm font-semibold mb-4 text-foreground">{t82}</h3>;
      $[182] = t82;
      $[183] = t83;
    } else {
      t83 = $[183];
    }
    let t84;
    if ($[184] !== t) {
      t84 = t("landing.footer.textGeneration");
      $[184] = t;
      $[185] = t84;
    } else {
      t84 = $[185];
    }
    let t85;
    if ($[186] !== t84) {
      t85 = <li><Link href="/models/text" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t84}</Link></li>;
      $[186] = t84;
      $[187] = t85;
    } else {
      t85 = $[187];
    }
    let t86;
    if ($[188] !== t) {
      t86 = t("landing.footer.textToImage");
      $[188] = t;
      $[189] = t86;
    } else {
      t86 = $[189];
    }
    let t87;
    if ($[190] !== t86) {
      t87 = <li><Link href="/models/text-to-image" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t86}</Link></li>;
      $[190] = t86;
      $[191] = t87;
    } else {
      t87 = $[191];
    }
    let t88;
    if ($[192] !== t) {
      t88 = t("landing.footer.imageToImage");
      $[192] = t;
      $[193] = t88;
    } else {
      t88 = $[193];
    }
    let t89;
    if ($[194] !== t88) {
      t89 = <li><Link href="/models/image-to-image" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t88}</Link></li>;
      $[194] = t88;
      $[195] = t89;
    } else {
      t89 = $[195];
    }
    let t90;
    if ($[196] !== t) {
      t90 = t("landing.footer.videoGeneration");
      $[196] = t;
      $[197] = t90;
    } else {
      t90 = $[197];
    }
    let t91;
    if ($[198] !== t90) {
      t91 = <li><Link href="/models/video" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t90}</Link></li>;
      $[198] = t90;
      $[199] = t91;
    } else {
      t91 = $[199];
    }
    let t92;
    if ($[200] !== t) {
      t92 = t("landing.footer.embeddings");
      $[200] = t;
      $[201] = t92;
    } else {
      t92 = $[201];
    }
    let t93;
    if ($[202] !== t92) {
      t93 = <li><Link href="/models/embeddings" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t92}</Link></li>;
      $[202] = t92;
      $[203] = t93;
    } else {
      t93 = $[203];
    }
    let t94;
    if ($[204] !== t) {
      t94 = t("landing.footer.vision");
      $[204] = t;
      $[205] = t94;
    } else {
      t94 = $[205];
    }
    let t95;
    if ($[206] !== t94) {
      t95 = <li><Link href="/models/vision" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t94}</Link></li>;
      $[206] = t94;
      $[207] = t95;
    } else {
      t95 = $[207];
    }
    let t96;
    if ($[208] !== t) {
      t96 = t("landing.footer.reasoning");
      $[208] = t;
      $[209] = t96;
    } else {
      t96 = $[209];
    }
    let t97;
    if ($[210] !== t96) {
      t97 = <li><Link href="/models/reasoning" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t96}</Link></li>;
      $[210] = t96;
      $[211] = t97;
    } else {
      t97 = $[211];
    }
    let t98;
    if ($[212] !== t) {
      t98 = t("landing.footer.toolCalling");
      $[212] = t;
      $[213] = t98;
    } else {
      t98 = $[213];
    }
    let t99;
    if ($[214] !== t98) {
      t99 = <li><Link href="/models/tools" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t98}</Link></li>;
      $[214] = t98;
      $[215] = t99;
    } else {
      t99 = $[215];
    }
    let t100;
    if ($[216] !== t) {
      t100 = t("landing.footer.webSearch");
      $[216] = t;
      $[217] = t100;
    } else {
      t100 = $[217];
    }
    let t101;
    if ($[218] !== t100) {
      t101 = <li><Link href="/models/web-search" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t100}</Link></li>;
      $[218] = t100;
      $[219] = t101;
    } else {
      t101 = $[219];
    }
    let t102;
    if ($[220] !== t) {
      t102 = t("landing.footer.discounted");
      $[220] = t;
      $[221] = t102;
    } else {
      t102 = $[221];
    }
    let t103;
    if ($[222] !== t102) {
      t103 = <li><Link href="/models/discounted" className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t102}</Link></li>;
      $[222] = t102;
      $[223] = t103;
    } else {
      t103 = $[223];
    }
    let t104;
    if ($[224] !== t101 || $[225] !== t103 || $[226] !== t85 || $[227] !== t87 || $[228] !== t89 || $[229] !== t91 || $[230] !== t93 || $[231] !== t95 || $[232] !== t97 || $[233] !== t99) {
      t104 = <ul className="space-y-2">{t85}{t87}{t89}{t91}{t93}{t95}{t97}{t99}{t101}{t103}</ul>;
      $[224] = t101;
      $[225] = t103;
      $[226] = t85;
      $[227] = t87;
      $[228] = t89;
      $[229] = t91;
      $[230] = t93;
      $[231] = t95;
      $[232] = t97;
      $[233] = t99;
      $[234] = t104;
    } else {
      t104 = $[234];
    }
    if ($[235] !== t104 || $[236] !== t83) {
      t7 = <div>{t83}{t104}</div>;
      $[235] = t104;
      $[236] = t83;
      $[237] = t7;
    } else {
      t7 = $[237];
    }
    t8 = filteredProviders.length > 0 && <div><h3 className="font-display text-sm font-semibold mb-4 text-foreground">{t("landing.footer.providers")}</h3><ul className="space-y-2">{filteredProviders.map(_temp)}</ul></div>;
    $[4] = config.docsUrl;
    $[5] = config.playgroundUrl;
    $[6] = configuredProviderIdSet;
    $[7] = t;
    $[8] = t10;
    $[9] = t11;
    $[10] = t12;
    $[11] = t13;
    $[12] = t14;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t10 = $[8];
    t11 = $[9];
    t12 = $[10];
    t13 = $[11];
    t14 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  let t15;
  if ($[238] !== t3 || $[239] !== t4 || $[240] !== t5 || $[241] !== t6 || $[242] !== t7 || $[243] !== t8) {
    t15 = <div className={t3}>{t4}{t5}{t6}{t7}{t8}</div>;
    $[238] = t3;
    $[239] = t4;
    $[240] = t5;
    $[241] = t6;
    $[242] = t7;
    $[243] = t8;
    $[244] = t15;
  } else {
    t15 = $[244];
  }
  let t16;
  if ($[245] !== t10 || $[246] !== t15 || $[247] !== t9) {
    t16 = <div className={t9}>{t10}{t15}</div>;
    $[245] = t10;
    $[246] = t15;
    $[247] = t9;
    $[248] = t16;
  } else {
    t16 = $[248];
  }
  let t17;
  if ($[249] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = new Date().getFullYear();
    $[249] = t17;
  } else {
    t17 = $[249];
  }
  let t18;
  if ($[250] !== t) {
    t18 = t("landing.footer.rights");
    $[250] = t;
    $[251] = t18;
  } else {
    t18 = $[251];
  }
  let t19;
  if ($[252] !== t18) {
    t19 = <p>© {t17} doteb.{" "}{t18}</p>;
    $[252] = t18;
    $[253] = t19;
  } else {
    t19 = $[253];
  }
  let t20;
  let t21;
  if ($[254] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <span className="hidden sm:inline">·</span>;
    t21 = <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" className="hover:underline underline-offset-4 hover:text-foreground">浙ICP备13013173号-2</a>;
    $[254] = t20;
    $[255] = t21;
  } else {
    t20 = $[254];
    t21 = $[255];
  }
  let t22;
  if ($[256] !== t19) {
    t22 = <div className="flex flex-col items-center gap-2 text-sm text-muted-foreground sm:flex-row">{t19}{t20}{t21}</div>;
    $[256] = t19;
    $[257] = t22;
  } else {
    t22 = $[257];
  }
  let t23;
  if ($[258] !== t) {
    t23 = t("landing.footer.privacy");
    $[258] = t;
    $[259] = t23;
  } else {
    t23 = $[259];
  }
  let t24;
  if ($[260] !== t23) {
    t24 = <Link href="/legal/privacy" className="text-sm text-muted-foreground hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t23}</Link>;
    $[260] = t23;
    $[261] = t24;
  } else {
    t24 = $[261];
  }
  let t25;
  if ($[262] !== t) {
    t25 = t("landing.footer.terms");
    $[262] = t;
    $[263] = t25;
  } else {
    t25 = $[263];
  }
  let t26;
  if ($[264] !== t25) {
    t26 = <Link href="/legal/terms" className="text-sm text-muted-foreground hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{t25}</Link>;
    $[264] = t25;
    $[265] = t26;
  } else {
    t26 = $[265];
  }
  let t27;
  if ($[266] !== t24 || $[267] !== t26) {
    t27 = <div className="flex items-center gap-6">{t24}{t26}</div>;
    $[266] = t24;
    $[267] = t26;
    $[268] = t27;
  } else {
    t27 = $[268];
  }
  let t28;
  if ($[269] !== t22 || $[270] !== t27) {
    t28 = <div className="border-t border-border/50 pt-8 mt-8 flex flex-col sm:flex-row items-center justify-between gap-4">{t22}{t27}</div>;
    $[269] = t22;
    $[270] = t27;
    $[271] = t28;
  } else {
    t28 = $[271];
  }
  let t29;
  if ($[272] !== t11 || $[273] !== t12 || $[274] !== t16 || $[275] !== t28) {
    t29 = <div className={t11}>{t12}{t16}{t28}</div>;
    $[272] = t11;
    $[273] = t12;
    $[274] = t16;
    $[275] = t28;
    $[276] = t29;
  } else {
    t29 = $[276];
  }
  let t30;
  if ($[277] !== t13 || $[278] !== t14 || $[279] !== t29) {
    t30 = <footer className={t13}>{t14}{t29}</footer>;
    $[277] = t13;
    $[278] = t14;
    $[279] = t29;
    $[280] = t30;
  } else {
    t30 = $[280];
  }
  return t30;
}
function _temp(provider) {
  return <li key={provider.id}><Link href={`/providers/${provider.id}`} className="text-sm hover:underline underline-offset-4 hover:text-foreground" prefetch={true}>{provider.name}</Link></li>;
}